import { Button } from "@ariakit/react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import startup from "./startup.mp3";
import { reboot } from "./style.css.ts";

function createTimeout(cb: () => void, ms: number) {
  const id = setTimeout(cb, ms);
  return () => void clearTimeout(id);
}

export function RebootButton() {
  const [isRebooting, setRebooting] = useState(false);

  useEffect(() => {
    if (isRebooting) {
      // Load early so that audio is ready once reboot is complete.
      const audio = new Audio(startup);
      document.body.classList.add(reboot.isRebooting);

      const clearRebooting = () => {
        document.body.classList.remove(reboot.isRebooting);
        setRebooting(false);
        void audio.play();
      };

      const clearTimeout = createTimeout(clearRebooting, 10000);

      return () => {
        clearRebooting();
        clearTimeout();
      };
    }
  }, [isRebooting]);

  return (
    <>
      {isRebooting &&
        createPortal(
          <div className={reboot.shuttingDown}>Shutting Down...</div>,
          document.body,
        )}

      <Button className={reboot.button} onClick={() => void setRebooting(true)}>
        Reboot
      </Button>
    </>
  );
}
